export default __webpack_public_path__ + "static/media/arihantbackground.ef8126bc.jpg";